import React from "react";
import { Scanner } from "@yudiel/react-qr-scanner";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

type ScannerType = {
  format: string;
  rawValue: string;
};
const QRScanner: React.FC = () => {
  const navigate = useNavigate();
  const { lang } = useParams<{ lang: string }>();
  const { t } = useTranslation();
  const handleResut = (result: ScannerType[]) => {
    if (result.length > 0) {
      const data = JSON.parse(result[0].rawValue);
      toast.success(t("common.found"));
      navigate(`/${lang}/status-check/${data.name}/${data.connectorId}`);
    }
  };
  return (
    <div className="w-full flex flex-col items-center justify-center h-screen">
      <div className="w-[300px] h-[350px] scanner-parent flex justify-center items-center border-green-500 rounded-xl border-4">
        <Scanner onScan={handleResut} />
      </div>
    </div>
  );
};

export default QRScanner;
